import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { selectTradeboxState } from "context/SyntheticsStateContext/selectors/tradeboxSelectors";
import { useSelector } from "context/SyntheticsStateContext/utils";
import { PerpType, TradeType, TradeTypeOverview } from "domain/synthetics/trade";
import { useLocalizedMap } from "lib/i18n";

import { SwipeTabs } from "components/SwipeTabs/SwipeTabs";
import Tabs from "components/Tabs/Tabs";

import { perpTradeTypeClassNames, tradeTypeClassNames, tradeTypeIcons, tradeTypeLabels } from "./tradeboxConstants";

const OPTIONS_PERP = Object.values(PerpType);

export function TradeBoxHeaderTabs({ isInCurtain: _isInCurtain }: { isInCurtain?: boolean }) {
  const localizedTradeTypeLabels = useLocalizedMap(tradeTypeLabels);
  const history = useHistory();
  const { setTradeType: onSelectTradeType, tradeType } = useSelector(selectTradeboxState);

  const [tradeTypeOverview, setTradeTypeOverview] = useState(TradeTypeOverview.Perp);
  const [tradeTypePerp, setTradeTypePerp] = useState(PerpType.Long);

  const onTradeTypeChange = useCallback(
    (type: TradeType) => {
      onSelectTradeType(type);
      if (tradeType !== type) {
        history.push(`/trade/${type.toLowerCase()}`);
      }
    },
    [history, onSelectTradeType, tradeType]
  );

  useEffect(() => {
    const desiredTradeType =
      tradeTypeOverview === TradeTypeOverview.Perp
        ? tradeTypePerp === PerpType.Long
          ? TradeType.Long
          : TradeType.Short
        : TradeType.Swap;

    // Only change the trade type if it's actually different — avoids spurious
    // chooseSuitableMarket calls that would overwrite the user's pool selection.
    if (tradeType !== desiredTradeType) {
      onTradeTypeChange(desiredTradeType);
    }
  }, [onTradeTypeChange, tradeType, tradeTypeOverview, tradeTypePerp]);

  useEffect(() => {
    if (tradeTypeOverview === TradeTypeOverview.Swap) {
      setTradeTypePerp(PerpType.Long);
    }
  }, [tradeTypeOverview]);

  const tabsOptionsOverview = useMemo(() => {
    return Object.values(TradeTypeOverview).map((type) => ({
      value: type,
      label: localizedTradeTypeLabels[type],
      // className: tradeTypeClassNames[type],
      // icon: tradeTypeIcons[type],
    }));
  }, [localizedTradeTypeLabels]);

  // const tabsOptionsPerp = useMemo(() => {
  //   return Object.values(PerpType).map((type) => ({
  //     value: type,
  //     label: localizedTradeTypeLabels[type],
  //     className: tradeTypeClassNames[type],
  //     icon: tradeTypeIcons[type],
  //   }));
  // }, [localizedTradeTypeLabels]);

  // if (!isInCurtain) {
  //   return (
  //     <Tabs
  //       options={tabsOptions}
  //       selectedValue={tradeType}
  //       onChange={onTradeTypeChange}
  //       size="l"
  //       qa="trade-direction"
  //     />
  //   );
  // }

  return (
    <div className="flex flex-col gap-[12px]">
      <Tabs
        options={tabsOptionsOverview}
        selectedValue={tradeTypeOverview}
        onChange={setTradeTypeOverview}
        size="large"
        qa="trade-direction"
      />
      {tradeTypeOverview === TradeTypeOverview.Perp && (
        <SwipeTabs
          // icons={tradeTypeIcons}
          options={OPTIONS_PERP}
          optionLabels={localizedTradeTypeLabels}
          option={tradeTypePerp}
          onChange={setTradeTypePerp}
          activeOptionClassnames={perpTradeTypeClassNames}
          wrapperClassname="!border-none"
          qa="trade-direction"
        />
      )}
    </div>
  );

  // return (
  //   <SwipeTabs
  //     icons={tradeTypeIcons}
  //     options={OPTIONS}
  //     optionLabels={localizedTradeTypeLabels}
  //     option={tradeType}
  //     onChange={onTradeTypeChange}
  //     optionClassnames={mobileTradeTypeClassNames}
  //     qa="trade-direction"
  //   />
  // );
}
